import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const IconChevronRight: FC<CommonIconProps> = ({ className }) => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      /* eslint-disable-next-line max-len */
      d="M8.357 5.72952L3.7024 1.07805C3.62725 1.02169 3.5343 0.994323 3.4406 1.00098C3.34691 1.00764 3.25876 1.04787 3.19234 1.11429C3.12592 1.18072 3.08568 1.26887 3.07903 1.36256C3.07237 1.45626 3.09973 1.54921 3.15609 1.62436L7.53674 6.00502L3.15609 10.3857C3.11136 10.4192 3.07437 10.462 3.0476 10.5111C3.02084 10.5602 3.00495 10.6144 3.00098 10.6702C2.99702 10.726 3.00508 10.7819 3.02463 10.8343C3.04418 10.8867 3.07476 10.9343 3.11429 10.9738C3.15383 11.0133 3.20139 11.0439 3.25377 11.0634C3.30615 11.083 3.36211 11.0911 3.41788 11.0871C3.47365 11.0831 3.52792 11.0672 3.57701 11.0405C3.62609 11.0137 3.66885 10.9767 3.7024 10.932L8.357 6.27739C8.42897 6.20438 8.46931 6.10598 8.46931 6.00346C8.46931 5.90094 8.42897 5.80253 8.357 5.72952Z"
      fill="white"
      stroke="white"
      strokeWidth="0.780449"
    />
  </svg>
);
